export default __webpack_public_path__ + "static/case1_img_1@2x-f2576812ad250dab89be679063d7e8a6.webp";